
export const VIDEOS_STATE = {
  ALL: 'all',
  ACTIVE: 'active',
  DELETED: 'deleted',
};

export const MEDIA_ASSET_STATE = {
  INITIAL: 'initial',
  PROCESSING: 'processing',
  READY: 'ready',
  ERROR: 'error',
};

export const ITEMS_PER_PAGE = 25;

export const FIELD_DEF_NAMES = {
  TAG: 'tag',
};
